var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section main-section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("title-comp", { attrs: { name: _vm.$t("title.warnings") } }),
        _vm.loading ? _c("hourglass") : _vm._e(),
        _c("div", {
          staticClass: "html-page-container",
          domProps: { innerHTML: _vm._s(_vm.content) },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }